module.exports = __webpack_public_path__ + "img/43_64.12fabf63.png";